import styled from "styled-components";
import { BaseButton } from "../Button";

export const InfoTrigger = styled(BaseButton)`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: none;
  color: var(--color-text-secondary);
  font-size: var(--text-md);
  cursor: help;
`;
